import { SignatureVerificationManager } from "@/utils/api-client/SignatureVerificationManager";
import { ApiClientFactory } from "./clients";

export class SignatureVerificationManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/signature-verification`
    );
  }

  createSignatureVerificationManager(
    authToken: string
  ): SignatureVerificationManager {
    return new SignatureVerificationManager(
      this.apiClientFactory.createAuthorizedApiClient(authToken)
    );
  }
}
